<template>
  <div class="item-select">
    <ul class="item-select">
      <li
        v-if="showAll"
        :class="{ actived: actived === '' }"
        class="item"
        @click="handleCLick('')"
      >
        全部
      </li>
      <li
        :class="{ actived: index === actived }"
        class="item"
        v-for="(item, index) of list"
        :key="index"
        @click="handleCLick(index)"
      >
        {{ item }}
      </li>
    </ul>
    <slot />
  </div>
</template>
  
  <script>
export default {
  name: "ItemSelect",
  model: {
    event: "onChange",
    prop: "actived",
  },
  props: {
    // prefix: {
    //   type: Array | Object,
    //   default: () => {
    //     return {};
    //   }
    // },
    list: {
      type: Array | Object,
      default: () => {
        return {};
      },
    },
    actived: {
      type: String | Number,
      default: "",
    },
    showAll: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    getList() {
      return [...this.prefix, ...this.list];
    },
  },
  methods: {
    handleCLick(index) {
      this.$emit("onChange", index);
      this.$emit("reload");
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.item-select {
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  .item {
    margin: 0;
    padding: 0 8px;
    border-radius: 4px;
    font-weight: 400;
    color: rgba(26, 26, 26, 0.9);
    font-size: 12px;
    cursor: pointer;
    transition: all 0.3s;
    margin-right: 5px;
    user-select: none;
    height: 24px;
    line-height: 24px;
    border: 1px solid #dcdfe6;
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      color: #db1c1b;
      border-color: #db1c1b;
    }
    &.actived {
      background: #db1c1b;
      color: #fff;
      border-color: #db1c1b;
    }
  }
}
</style>
  